import EstudianteMain from "./routes/estudiantemain/index";
import BibliotecaMain from "./routes/bibliotecariamain/index";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoutes";
import HomePage from "./routes/homepage";
import ProfileSettings from "./routes/profilesettings";
import LibroDetails from "./routes/librodetails";
import MisPrestamos from "./routes/misPrestamos/misPrestamos";
import ResultadosBusqueda from "./routes/busquedaResultados/busquedaResultados";
import NotFound from "./routes/notFound";
import LoginTotal from "./routes/login/index";
import { UserProvider } from "./context/userContext";
import "./App.css";

function App() {
  return (
    <UserProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signin" element={<LoginTotal />} />
        <Route
          path="/menuestudiante"
          element={
            <ProtectedRoute>
              <EstudianteMain />
            </ProtectedRoute>
          }
        />
        <Route
          path="/menuestudiante/libros/:libroid"
          element={
              <LibroDetails />
          }
        />
        {/* </Route> */}
        <Route
          path="/menubiblioteca"
          element={
            <ProtectedRoute>
              <BibliotecaMain />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil"
          element={
            <ProtectedRoute>
              <ProfileSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="misprestamos"
          element={
            <ProtectedRoute>
              <MisPrestamos />
            </ProtectedRoute>
          }
        />
        <Route path="/resultados-busqueda" element={<ResultadosBusqueda />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </UserProvider>
  );
}

export default App;
